function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import classnames from 'classnames';
import { Button, Select, Switch, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDataViewContext } from './context';
import { RefreshTimeout } from '../../enums/refresh-timeout';
var REFRESH_OPTS_QS_PARAM = '_ropts';
export var DataViewRefresh = function DataViewRefresh(props) {
  var _urlParams$get;
  var _useDataViewContext = useDataViewContext(),
    _useDataViewContext2 = _slicedToArray(_useDataViewContext, 2),
    state = _useDataViewContext2[0],
    dispatch = _useDataViewContext2[1];
  var showRefreshOptions;
  var urlParams = new URLSearchParams(window.location.search);
  var showRefreshOptsParams = (_urlParams$get = urlParams.get(REFRESH_OPTS_QS_PARAM)) !== null && _urlParams$get !== void 0 ? _urlParams$get : false;
  if (showRefreshOptsParams !== undefined && (showRefreshOptsParams === 'true' || showRefreshOptsParams === '1')) {
    showRefreshOptions = true;
  }
  var hideAutoRefreshOptions = showRefreshOptions === undefined ? props.hideAutoRefreshOptions : !showRefreshOptions;
  var hideAllRefresh = props.hideRefresh && props.hideAutoRefreshOptions;
  var activeRefreshRequestExists = state.refreshRequested || state.autoRefreshRequested;
  var loaderAnimationIsActive = state.loading || state.dataSourceLoading || state.refreshing;
  var onRefreshEnabledChange = function onRefreshEnabledChange(checked, _ev) {
    var _props$onRefreshEnabl;
    (_props$onRefreshEnabl = props.onRefreshEnabledChange) === null || _props$onRefreshEnabl === void 0 ? void 0 : _props$onRefreshEnabl.call(props, checked);
  };
  var onRefreshTimeoutChange = function onRefreshTimeoutChange(value, _option) {
    var _props$onRefreshTimeo;
    (_props$onRefreshTimeo = props.onRefreshTimeoutChange) === null || _props$onRefreshTimeo === void 0 ? void 0 : _props$onRefreshTimeo.call(props, value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('data-view-refresh', {
      hidden: hideAllRefresh
    })
  }, !hideAutoRefreshOptions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Switch, {
    size: "small",
    checked: state.refreshEnabled,
    onChange: onRefreshEnabledChange
  }), /*#__PURE__*/React.createElement("span", null, "Auto-Refresh"), /*#__PURE__*/React.createElement(Select, {
    className: classnames('data-view-timeout-select'),
    size: "small",
    disabled: !state.refreshEnabled,
    options: RefreshTimeout.getAll().map(function (t) {
      return {
        value: t,
        label: RefreshTimeout.getLabel(t)
      };
    }),
    value: state.refreshTimeout,
    onChange: onRefreshTimeoutChange
  })), !props.hideRefresh && /*#__PURE__*/React.createElement(Tooltip, {
    title: "Refresh"
  }, /*#__PURE__*/React.createElement(Button, {
    className: classnames('data-view-refresh-toggle'),
    size: "small",
    shape: "round",
    onClick: function onClick() {
      if (!state.dataSourceLoading && !activeRefreshRequestExists) {
        var _props$onRefreshClick;
        dispatch({
          type: 'SET_REFRESH_REQUESTED'
        });
        (_props$onRefreshClick = props.onRefreshClick) === null || _props$onRefreshClick === void 0 ? void 0 : _props$onRefreshClick.call(props);
      }
    },
    disabled: !state.refreshEnabled
  }, /*#__PURE__*/React.createElement(ReloadOutlined, {
    spin: loaderAnimationIsActive
  }))));
};